import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainDenunciasComponent } from './main-denuncias/main-denuncias.component';
import { MaterialModule } from 'src/app/material.module';
import { ListDenunciasComponent } from './list-denuncias/list-denuncias.component';
import { DenunciasService } from 'src/app/pages/services/denuncias/denuncia.service';
import { DenunciaDetailDialogComponent } from './denuncia-detail-dialog/denuncia-detail-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { UpdateModalComponent } from './update-modal/update-modal.component';


@NgModule({
  declarations: [
    MainDenunciasComponent,
    ListDenunciasComponent,
    DenunciaDetailDialogComponent,
    UpdateModalComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule
  ],
  exports: [
    MainDenunciasComponent,
    ListDenunciasComponent
  ],
  providers: [
    DenunciasService 
  ],
})
export class DenunciasModule { }

